<template>
  <div class="w-full overflow-visible sm:overflow-hidden">
    <h1 class="text-[15vw] leading-[0.8] font-semibold font-fancy text-flax-smoke-900 flex flex-wrap items-baseline">
      <!-- Mobile Layout -->
      <div class="relative w-full sm:hidden">
        <div class="flex items-baseline whitespace-nowrap w-full">
          <span class="inline-block">NHI</span>
          <span class="inline-block mx-[0.2em]">Y.</span>
          <span class="inline-block">NGO</span>
          <span class="inline-block ml-[0.2em] align-baseline">✴︎</span>
        </div>
      </div>
      
      <!-- Desktop Layout -->
      <div class="hidden sm:flex items-baseline">
        <span class="inline-block">NHI</span>
        <span class="inline-block mx-[0.2em]">Y.</span>
        <span class="inline-block">NGO</span>
      </div>
    </h1>
  </div>
</template>

<script setup lang="ts">
</script>